"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PieChart = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/PieChart"));

// Generated by script, don't edit it please.
var PieChart = (0, _createSvgIcon["default"])({
  as: _PieChart["default"],
  ariaLabel: 'pie chart',
  category: 'charts',
  displayName: 'PieChart'
});
var _default = PieChart;
exports["default"] = _default;
module.exports = exports.default;